
<!-- Latest compiled and minified CSS -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous">

<!-- Optional theme -->
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap-theme.min.css" integrity="sha384-rHyoN1iRsVXV4nD0JutlnGaslCJuC7uwjduW9SVrLvRYooPp2bWYgmgJQIXwl/Sp" crossorigin="anonymous">

<!-- Latest compiled and minified JavaScript -->
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js" integrity="sha384-Tc5IQib027qvyjSMfHjOMaLkfuWVxZxUPnCJA7l2mCWNIpG9mGCD8wGNIcPD7Txa" crossorigin="anonymous"></script>
<div class="container">
    <div class="d-flex align-items-center p-3 my-3 text-white bg-purple rounded shadow-sm">
    <div class="lh-1">
      <h1 class="h6 mb-0 text-white lh-1">        <i class="fas fa-globe"></i> 
        Visitors Panel - {{counter}}</h1>
    </div>
    </div>
  <app-add-item></app-add-item>
  <br>
    <table *ngIf="items?.length > 0; else noitem" class="table">
        <thead>
          <tr>
            <th scope="col"><i class="fas fa-flag"></i> Ip</th>
            <th scope="col"><i class="fab fa-windows"></i> Os</th>

            <th scope="col"><i class="fab fa-chrome"></i> Browser </th>
            <th scope="col"><i class="fas fa-globe-africa"></i> Country</th>
            <th scope="col"><i class="fas fa-globe-africa"></i> Session</th>

          </tr>


          <tr>
        </thead>
        <tbody>
    
          <tr *ngFor="let item of items" >
              <td > <span > {{item.ip}} </span> 
              </td>
              <td > <span > {{item.os}} </span> 
                </td>
                <td > <span > {{item.browser}} </span> 
                </td>
                <td > <span > {{item.country}} </span> 
                </td>
                <td > <span > {{item.sessionid}} </span> 
                </td>
          
            

            
          </tr>
        </tbody>
      </table>
</div>


<ng-template #noitem>
<hr>
<h1>No Item</h1>
</ng-template>